var $169760630fc73b3d$exports = {};
$169760630fc73b3d$exports = {
    "colorPicker": `Color picker`,
    "twoDimensionalSlider": `2D slider`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorSwatch": `color swatch`,
    "transparent": `transparent`
};


export {$169760630fc73b3d$exports as default};
//# sourceMappingURL=en-US.mjs.map
